/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getBrandsForSearchResult } from '../fn/product-search/get-brands-for-search-result';
import { GetBrandsForSearchResult$Params } from '../fn/product-search/get-brands-for-search-result';
import { getCollectorsByPackagingUnitId } from '../fn/product-search/get-collectors-by-packaging-unit-id';
import { GetCollectorsByPackagingUnitId$Params } from '../fn/product-search/get-collectors-by-packaging-unit-id';
import { getPackagingUnitId } from '../fn/product-search/get-packaging-unit-id';
import { GetPackagingUnitId$Params } from '../fn/product-search/get-packaging-unit-id';
import { getProductNamesAndBrands } from '../fn/product-search/get-product-names-and-brands';
import { GetProductNamesAndBrands$Params } from '../fn/product-search/get-product-names-and-brands';
import { getShopsByPackagingUnitId } from '../fn/product-search/get-shops-by-packaging-unit-id';
import { GetShopsByPackagingUnitId$Params } from '../fn/product-search/get-shops-by-packaging-unit-id';
import { getVariantsByPackagingUnitId } from '../fn/product-search/get-variants-by-packaging-unit-id';
import { GetVariantsByPackagingUnitId$Params } from '../fn/product-search/get-variants-by-packaging-unit-id';
import { PageProductSearchResponse } from '../models/page-product-search-response';
import { PageProductShopsPageResponse } from '../models/page-product-shops-page-response';
import { ProductCollectorResponse } from '../models/product-collector-response';
import { ProductVariantResponse } from '../models/product-variant-response';
import { searchProduct } from '../fn/product-search/search-product';
import { SearchProduct$Params } from '../fn/product-search/search-product';
import { SearchTextExtension } from '../models/search-text-extension';


/**
 * Product search and discovery endpoints. All endpoints require authentication (no specific role restriction beyond isAuthenticated).
 */
@Injectable({ providedIn: 'root' })
export class ProductSearchService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchProduct()` */
  static readonly SearchProductPath = '/search/products';

  /**
   * Search products by filter.
   *
   * Search products by the specified ProductSearchDetails filter object
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchProduct()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchProduct$Response(params: SearchProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<PageProductSearchResponse>> {
    const obs = searchProduct(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Search products by filter.
   *
   * Search products by the specified ProductSearchDetails filter object
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchProduct$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchProduct(params: SearchProduct$Params, context?: HttpContext): Observable<PageProductSearchResponse> {
    const resp = this.searchProduct$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageProductSearchResponse>): PageProductSearchResponse => r.body)
    );
  }

  /** Path part for operation `getBrandsForSearchResult()` */
  static readonly GetBrandsForSearchResultPath = '/search/products/brands';

  /**
   * Get all brands by filter.
   *
   * Get all possible brand values by the specified ProductSearchDetails filter object
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBrandsForSearchResult()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getBrandsForSearchResult$Response(params: GetBrandsForSearchResult$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    const obs = getBrandsForSearchResult(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all brands by filter.
   *
   * Get all possible brand values by the specified ProductSearchDetails filter object
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBrandsForSearchResult$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getBrandsForSearchResult(params: GetBrandsForSearchResult$Params, context?: HttpContext): Observable<Array<string>> {
    const resp = this.getBrandsForSearchResult$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `getPackagingUnitId()` */
  static readonly GetPackagingUnitIdPath = '/search/products/{packagingUnitId}';

  /**
   * Get data from the specified packagingUnitId.
   *
   * Get data from the specified packagingUnitId
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPackagingUnitId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPackagingUnitId$Response(params: GetPackagingUnitId$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductVariantResponse>> {
    const obs = getPackagingUnitId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get data from the specified packagingUnitId.
   *
   * Get data from the specified packagingUnitId
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPackagingUnitId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPackagingUnitId(params: GetPackagingUnitId$Params, context?: HttpContext): Observable<ProductVariantResponse> {
    const resp = this.getPackagingUnitId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProductVariantResponse>): ProductVariantResponse => r.body)
    );
  }

  /** Path part for operation `getVariantsByPackagingUnitId()` */
  static readonly GetVariantsByPackagingUnitIdPath = '/search/products/{packagingUnitId}/variants';

  /**
   * Get all variants by specified packagingUnitId.
   *
   * Get all variants by specified packagingUnitId
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVariantsByPackagingUnitId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVariantsByPackagingUnitId$Response(params: GetVariantsByPackagingUnitId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductVariantResponse>>> {
    const obs = getVariantsByPackagingUnitId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all variants by specified packagingUnitId.
   *
   * Get all variants by specified packagingUnitId
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getVariantsByPackagingUnitId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVariantsByPackagingUnitId(params: GetVariantsByPackagingUnitId$Params, context?: HttpContext): Observable<Array<ProductVariantResponse>> {
    const resp = this.getVariantsByPackagingUnitId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ProductVariantResponse>>): Array<ProductVariantResponse> => r.body)
    );
  }

  /** Path part for operation `getShopsByPackagingUnitId()` */
  static readonly GetShopsByPackagingUnitIdPath = '/search/products/{packagingUnitId}/shops';

  /**
   * Get the shop based prices by specified packagingUnitId.
   *
   * Get the shop based prices by specified packagingUnitId
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getShopsByPackagingUnitId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getShopsByPackagingUnitId$Response(params: GetShopsByPackagingUnitId$Params, context?: HttpContext): Observable<StrictHttpResponse<PageProductShopsPageResponse>> {
    const obs = getShopsByPackagingUnitId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the shop based prices by specified packagingUnitId.
   *
   * Get the shop based prices by specified packagingUnitId
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getShopsByPackagingUnitId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getShopsByPackagingUnitId(params: GetShopsByPackagingUnitId$Params, context?: HttpContext): Observable<PageProductShopsPageResponse> {
    const resp = this.getShopsByPackagingUnitId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageProductShopsPageResponse>): PageProductShopsPageResponse => r.body)
    );
  }

  /** Path part for operation `getCollectorsByPackagingUnitId()` */
  static readonly GetCollectorsByPackagingUnitIdPath = '/search/products/{packagingUnitId}/collectors';

  /**
   * Get all collectors by specified packagingUnitId.
   *
   * Get all collectors by specified packagingUnitId
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCollectorsByPackagingUnitId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCollectorsByPackagingUnitId$Response(params: GetCollectorsByPackagingUnitId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductCollectorResponse>>> {
    const obs = getCollectorsByPackagingUnitId(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all collectors by specified packagingUnitId.
   *
   * Get all collectors by specified packagingUnitId
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCollectorsByPackagingUnitId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCollectorsByPackagingUnitId(params: GetCollectorsByPackagingUnitId$Params, context?: HttpContext): Observable<Array<ProductCollectorResponse>> {
    const resp = this.getCollectorsByPackagingUnitId$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ProductCollectorResponse>>): Array<ProductCollectorResponse> => r.body)
    );
  }

  /** Path part for operation `getProductNamesAndBrands()` */
  static readonly GetProductNamesAndBrandsPath = '/search/products/names-and-brands';

  /**
   * Get product names and brands based on the given parameter.
   *
   * If the parameter is present in both the name and the brand of the same product, then 2 results will be shown.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductNamesAndBrands()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductNamesAndBrands$Response(params: GetProductNamesAndBrands$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SearchTextExtension>>> {
    const obs = getProductNamesAndBrands(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get product names and brands based on the given parameter.
   *
   * If the parameter is present in both the name and the brand of the same product, then 2 results will be shown.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductNamesAndBrands$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductNamesAndBrands(params: GetProductNamesAndBrands$Params, context?: HttpContext): Observable<Array<SearchTextExtension>> {
    const resp = this.getProductNamesAndBrands$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SearchTextExtension>>): Array<SearchTextExtension> => r.body)
    );
  }

}
